<template>
  <article class="c-article-list list">
    <a href="https://www.partsdata.de/usb-2.0/usb-2.0-montagekabel-industriekabel/usb-kabel-fuer-schleppketten/cu-chain-120/usb-2.0-kabel-pur-fuer-industrie-u.-schleppkette-typ-a-auf-b-12m?c=2519">
      <div class="c-article-list__pricebox">
        <div class="c-article-list__price">EUR <span>179,69</span></div>
        Preise inkl. 19% MwSt. <br>zzgl. Versandkosten
      </div>
    </a>
    <a href="https://www.partsdata.de/usb-2.0/usb-2.0-montagekabel-industriekabel/usb-kabel-fuer-schleppketten/cu-chain-120/usb-2.0-kabel-pur-fuer-industrie-u.-schleppkette-typ-a-auf-b-12m?c=2519">
      <figure class="c-article-list__image">
        <img src="https://www.partsdata.de/media/image/72/fa/3e/usb-2.0-kabel-pur-fuer-industrie-u.-schleppkette-typ-a-auf-b-12m_CU-CHAIN-120_1_130x130.jpg" srcset="https://www.partsdata.de/media/image/4a/50/08/usb-2.0-kabel-pur-fuer-industrie-u.-schleppkette-typ-a-auf-b-12m_CU-CHAIN-120_1_260x260.jpg 2x">
      </figure>
      <div class="c-article-list__badgebox">
        <span class="c-article-list__badge has--length">12 m</span>
      </div>
      <h2>USB 2.0 Kabel PUR für Industrie u. Schleppkette, Typ A auf B, 12m</h2>
    </a>
    <a href="https://www.partsdata.de/usb-2.0/usb-2.0-montagekabel-industriekabel/usb-kabel-fuer-schleppketten/cu-chain-120/usb-2.0-kabel-pur-fuer-industrie-u.-schleppkette-typ-a-auf-b-12m?c=2519">
      <dl class="c-article-list__information">
        <dt>Art.-Nr</dt>
        <dd>CU-CHAIN-120</dd>
        <dt>Auf Lager</dt>
        <dd class="success">3 Stk.</dd>
      </dl>
    </a>
    <div class="c-article-list__buttonrow">
      <form class="c-form" name="sAddToBasket" method="post" action="https://www.partsdata.de/checkout/addArticle">
        <button class="c-buyaction-short">
          <span class="c-buyaction-short__cart-icon" name="In den Warenkorb"></span>
          <span>In den Warenkorb</span>
        </button>
        <input class="c-form__input" type="text" name="sQuantity" id="sQuantity" value="1">
        <input type="hidden" name="sActionIdentifier" value="">
        <input type="hidden" name="sAddAccessories" id="sAddAccessories" value="">
        <input type="hidden" name="sAdd" value="CU-CHAIN-120">
        <input id="customizingGroupId" type="hidden" name="customizingGroupId" value="">
        <input type="hidden" name="__csrf_token" value="h4vvTmfcpEFGtiIrPE73GaQICzXRtL"></form>
      <a href="https://www.partsdata.de/usb-2.0/usb-2.0-montagekabel-industriekabel/usb-kabel-fuer-schleppketten/cu-chain-120/usb-2.0-kabel-pur-fuer-industrie-u.-schleppkette-typ-a-auf-b-12m?c=2519">
        <span class="button button--ghost">Mehr Infos</span>
      </a>
    </div>
  </article>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({

})
</script>

<style scoped lang="sass">
  .c-article-list
    padding: 0.538em
    padding-top: 0.738em
    padding-left: 0
    padding-right: $margin-main-elements
    position: relative
    min-height: 9.4em
    border-top: 1px solid $light-grey
    //overflow: auto

    &__image
      margin: 0 1.12em 0 $margin-main-elements
      padding: 0
      float: left
      width: 130px
      height: 130px

      img
        width: 10em
        border: 1px solid $light-grey
    &__badgebox
      position: absolute
      left: 5.5em
      top: 1.2em
      width: 5em
      .c-article-list__badge
        float: right
        margin-top: 0.2em
        background-color: $green
        padding: 0.1em 1em
        font-size: 0.95em
        border-radius: 1em 0 0 1em
        color: white
        &.is--highlighted
          background-color: $yellow
        &.is--new
          background-color: $yellow
    h1
      padding-top: 0em
      margin-bottom: .5em
      font-weight: 600

    h2
      margin-top: 0px
      font-weight: 600
      width: 32em

    a
      color: #000
      display: block

    &__information
      position: absolute
      bottom: 0
      left: 11em
      font-size: 1.077em
      dt
        display: inline-block
        width: 6em
        position: relative

      dd
        display: inline
        font-weight: bold
        margin-left: 0

        &:after
          // Zeilenumbruch hinzufügen
          content: "\A"
          white-space: pre

    &__pricebox
      float: right
      text-align: right
      color: darken($light-grey, 10%)
      .c-article-list__price
        color: $dark-blue
        font-size: 1.692em
        margin-bottom: 1px
        span
          font-weight: 700

    &__buttonrow
      margin: 0 0 0.7em 0
      position: absolute
      bottom: 0em
      right: 0em
      width: 23em
      form
        input
          width: 5em
          padding: .62em .9em
          float: right
          margin-right: -1em
          border-top-right-radius: 0em
          border-bottom-right-radius: 0em
          border-right: none

    &:last-child
      border-bottom: 1px solid $light-grey

      .button  .button-hover

      .ghost:hover
        background: transparent
        color: #000
        border: 1px solid #000

  //&:active
    .button
    .button-active

  .paging
    float: right
    margin-top: 1em

    .paging--display
      margin: 0em 1em

    a
      display: inline-block

      &:before
        display: block
        color: #000
        border: 1px solid $light-grey
        padding: 0.6em 0.7em
        font-size: 1.3em
        font-family: FontAwesome
        border-radius: $border-radius

      &:hover:before
        background-color: $light-grey

      &.last:before
        content: "\f101"

      &.next:before
        content: "\f105"

      &.prev:before
        content: "\f104"

      &.first:before
        content: "\f100"

</style>
